import React from "react";
import NodeStatus from "components/NodeStatus";
import * as jsPopup from "reactjs-popup";
import DeviceActions from "./DeviceActions";

export default function DeviceRow({
  device,
  listSelect,
  setListSelect,
  setMapCenter,
  setMapZoom,
  setCalcZoom, // Add this new prop
  getBasicDeviceIcon,
  selectedDevices = [],
  showSettingsState,
  toggleDevice,
}) {
  const handleDeviceClick = () => {
    // Center and zoom to the specific device
    const coords = JSON.parse(device.location);
    setMapCenter({ lat: coords.lat, lng: coords.lng });
    setMapZoom(16); // Close zoom for individual device
    setCalcZoom && setCalcZoom(16); // Update calc zoom if available

    // Keep existing listSelect functionality
    setListSelect(!listSelect);
  };

  return (
    <div
      onClick={handleDeviceClick}
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        borderBottom: "1px solid #aaa",
        cursor: "pointer",
      }}
    >
      <div
        style={{
          width: "25%",
          maxWidth: 100,
          display: "flex",
          flexDirection: "column",
          height: "100%",
          alignItems: "center",
          position: "relative",
          paddingTop: 5,
          justifyContent: "space-around",
        }}
      >
        <img
          src={getBasicDeviceIcon(
            {
              ...device,
              data: [
                {
                  is_offline: device.is_offline,
                  status: device.status,
                },
              ],
            },
            "img"
          )}
          style={{
            height: 40,
            marginRight: 10,
            marginLeft: "auto",
            marginRight: "auto",
          }}
        />
        <div style={{ color: "white" }}>{device.node_id}</div>
      </div>
      <jsPopup.Popup
        on="hover"
        position="left center"
        trigger={
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              marginBottom: 10,
              width: "70%",
            }}
          >
            <p
              style={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                width: "100%",
                color: "white",
              }}
            >
              {device.alias}
            </p>
            {showSettingsState ? (
              <DeviceActions
                device={device}
                selectedDevices={selectedDevices}
                toggleDevice={toggleDevice}
              />
            ) : (
              <NodeStatus
                device={{
                  ...device,
                  data: [
                    {
                      is_offline: false,
                      status: device.status === -1 ? 0 : device.status,
                    },
                  ],
                }}
              />
            )}
          </div>
        }
      >
        <div
          style={{
            backgroundColor: "#1b3f62",
            padding: 3,
            borderRadius: 10,
            color: "white",
          }}
        >
          {device.alias}
        </div>
      </jsPopup.Popup>
    </div>
  );
}
